document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu toggle is handled by the Luxury Header section script.
  // Do not add menu listeners here — they conflict with the header's
  // delegated click handler and cause the drawer to immediately close.

  document.querySelectorAll('[data-recipient-card]').forEach((card) => {
    card.addEventListener('click', () => {
      document.querySelectorAll('[data-recipient-card]').forEach((item) => item.classList.remove('is-active'));
      card.classList.add('is-active');
    });
  });
});